"use client";

import { ReactNode } from "react";
import { ErrorBoundary } from "@/components/common/error-boundary";

export const RecommendationRouter = ({
  recommendations,
  children,
}: {
  recommendations: ReactNode;
  children?: ReactNode;
}) => {
  if (recommendations) {
    return (
      <ErrorBoundary fallback={null}>
        <div className={"mt-24 empty:hidden"}>{recommendations}</div>
      </ErrorBoundary>
    );
  }

  if (!children) {
    return null;
  }

  return <div className={"mt-24 empty:hidden"}>{children}</div>;
};
